import { countUniqueFailedSearchesOnSearchId } from '../queries/countUniqueFailedSearchesOnSearchId'

export const totalFailedSearchesGauge = {
  id: 'total_search',
  queries: [countUniqueFailedSearchesOnSearchId],
  title: 'Failed searches',
}
